import { makeStyles } from 'tss-react/mui'

const ExpirePasswordStyle = makeStyles()((theme: any) => ({
  autoCompleteTextInput: {
    '& input': {
      marginTop: '-9px',
      marginBottom: '-9px',
      '&:disabled': {
        color: 'rgb(84, 84, 84)',
        backgroundColor: 'rgba(239, 239, 239, 0.3)',
        borderColor: 'rgba(118, 118, 118, 0.3)',
      },
    },
  },
  checkBox: {
    marginTop: '-6px',
    '& .MuiFormControlLabel-root': {
      marginLeft: '-2px',
      '& .MuiCheckbox-colorPrimary': {
        padding: theme.spacing(0, 0.625, 0, 0),
      },
      '& .MuiTypography-body1': {
        fontSize: '14px',
        lineHeight: '16px',
        color: '#4F5A65',
      },
    },
  },
}))

export default ExpirePasswordStyle
